export default function() {
    const widgetName = 'interStateButtons';
    const widgetOpts = interStateButtonsOpts;
  
    return saffire.widgets.cardWidget($(`#${widgetName}`), {
      currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
      buyNowButton: {
        visible: false,
        text: ''
      },
      cardWidgetLoaded: function(data, owl, hasData) {
        if ($('body').hasClass('subpage-theme--first-interstate')) {
          $(`#${widgetName}`).insertBefore('.content');
        } else {
          $(`#${widgetName}`).hide();
        }
      },
      itemsPerPanel: 1,
      hasImages: false,
      lazyLoadImages: false,
      imageIsBackground: false,
      link: ['all'], // [], ['all'], ['image', 'title', 'description']
      maxItemsVisible: 4,
      moreButton: {
        visible: false,
        text: ''
      },
      scriptPath:  widgetOpts.scriptPath,
      showDescription: false,
      slideshow: false,
      textOverImage: false
    });
  
  }